import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import * as moment from 'moment';
import {environment as env} from '../../../environments/environment';
import {map} from 'rxjs/operators';
import {DateUtils} from '../../shared/date-utils';
import {ConfigService} from '../../core/services/config/config.service';
import {ComponentConfiguration} from '../../core/models/config';

@Injectable({
    providedIn: 'root'
})
export class OvrdAlertsService {
    private defaultConfig = {
        id: 'overrideAlerts',
        name: 'Override Alerts',
        type: 'chart',
        config: {
            metric: {
                overrides: {
                    name: 'Overrides',
                    style: {color: '#0B3EF9'}
                }
            }
        }
    };

    constructor(private http: HttpClient, private configService: ConfigService) {
    }

    public getComponentConfig(): ComponentConfiguration {
        const config = this.configService.getComponentConfiguration('dashboard', 'overrideAlerts');
        return config ? config : this.defaultConfig;
    }

    public getOverrideAlerts(request: any): Observable<OvrdAlertsModel[]> {
        return this.http.post<OvrdAlertsModel[]>(`${env.apiBaseUrl}/dashboard/override_alerts`,
            {
                ...request,
                startDate: moment(request.startDate).format('YYYY-MM-DD'),
                endDate: moment(request.endDate).format('YYYY-MM-DD')
            }).pipe(map(resp => {
            resp.forEach(item => {
                item.effDt = DateUtils.convertToLocaleDateString(item.effDt as string);
                item.key = item.rsid + '::' + item.od + '::' + item.effDt;
            });
            return resp;
        }));
    }
}

export class OvrdAlertsModel {
    rsid: string;
    diffFrmFcst: number;
    od: string;
    depDt: string | Date;
    effDt: string | Date;
    key?: string;
}
